module.exports = __webpack_public_path__ + "img/web_purpose.743b8c25.jpg";